import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function StoragePicker({ className, disabled, label, storage, storages, onChange }) {
  const [currentStorage, setCurrentStorage] = useState(undefined)

  const onStoragePick = newStorage => {
    if (newStorage === currentStorage) return
    setCurrentStorage(newStorage)
    onChange && onChange(newStorage)
  }

  useEffect(() => {
    setCurrentStorage(storage)
  }, [storage])

  return (
    <div
      className={clsx(className, 'hwd-header__controls', disabled && 'hwd-header__controls--disabled')}
      style={{ margin: 'unset' }} // This is a hack, since hwd-header__controls has a margin
    >
      <div className="hwd-header__storage">
        {label && <div className="hwd-header__label text-dark">{label}</div>}
        {storages.map(({ label, value }) => (
          <label key={value} className="hwd-header__storage-tile">
            <input
              type="radio"
              value={value}
              style={{ display: 'none' }}
              checked={currentStorage === value}
              onChange={() => onStoragePick(value)}
            />
            <span className="hwd-header__options-display">{label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

StoragePicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  storage: PropTypes.string,
  storages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  onChange: PropTypes.func
}

StoragePicker.defaultProps = {
  disabled: false,
  storages: []
}
